'use strict';

(function () {
  angular.module('zp').controller('PostItemController', postItemController);

  /**@ngInject */
  function postItemController($q, $timeout, $sce, $state, PostsService, LoaderService) {
    var vm = this;

    vm.post = null;
    vm.posts = [];
    vm.postContent = null;

    vm.openPost = openPost;

    /**Activate */
    (function () {
      LoaderService.start();
      loadPost().then(loadPostContent).then(loadAllPosts).then(function () {
        $timeout(LoaderService.stop, 500);
      });
    })();

    function loadPost() {
      return PostsService.getByAlias($state.params.alias).then(function (post) {
        vm.post = post;
      });
    }

    function loadPostContent() {
      if (!vm.post) {
        return;
      }
      if (vm.post.type === 'blog') {
        return PostsService.getContent(vm.post.url).then(function (content) {
          vm.postContent = $sce.trustAsHtml(content);
        });
      }
      if (vm.post.type === 'vlog') {
        return $q.when(function () {
          vm.postContent = $sce.trustAsResourceUrl(vm.post.url);
        }());
      }
    }

    function openPost(post) {
      $state.go('nav.post-item', { alias: post.alias });
    }

    function loadAllPosts() {
      vm.posts.length = 0;
      return PostsService.getAll().then(function (response) {
        vm.posts = response.filter(function (item) {
          return item.id !== vm.post.id;
        });
      });
    }
  }
})();